document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutations, obs) => {
    const contElement = document.querySelector('.samitaWS_volumeTable_product_form');

    if (contElement == undefined || contElement == null){
      return;
    }
    
    const elementToMove = contElement.querySelector('.samitaWS-volumeTable-widget-wrapper');
    const referenceElement = document.querySelector('.product-table-volume');
    const otherReferenceElement = document.querySelector('.section-for-desktop-components-two');

    if (elementToMove == undefined || elementToMove == null){
      return;
    }

    const titleSection = document.createElement('span');
    titleSection.textContent = "Compra Mas, Paga Menos";
    titleSection.style.padding = "2px 10px";
    titleSection.style.color = "white";
    titleSection.style.position = "relative";
    titleSection.style.top = "-10px";
    titleSection.style.right = "-40%";
    titleSection.style.background = "#C12D46";
    titleSection.style.borderRadius = "8px";

    const first = elementToMove.querySelector(".samitaWS-volumeDisplayTableForm");
    const second = first.querySelector(".volumeDisplayTableForm-options");
    const table = second.querySelector("table"); // Assuming the table is inside this div

    // Insert the span before the table
    // if (table) {
    //     second.insertBefore(titleSection, table);
    // }

    first.style.padding = "5px";
    

    const legend = document.createElement("div");
    // Aplicamos estilos al contenedor (opcional)
    legend.style.textAlign = "center"; // Centramos el texto
    legend.style.margin = "0px 0"; // Espaciado
    
    // Creamos elementos separados para cada línea (mejor para estilizar)
    const line1 = document.createElement("p");
    line1.textContent = "";
    // Estilos para la primera línea (negrita, gris oscuro)
    line1.style.fontWeight = "bold";
    line1.style.color = "#333"; // Gris oscuro casi negro
    line1.style.margin = "0 0 5px 0"; // Espaciado inferior
    
    //const line2 = document.createElement("p");
    //line2.textContent = "Precios sujetos a cambios y/o disponibilidad";
    //line2.style.margin = "0"; // Eliminamos margen por defecto
    //line2.style.color = "#555"; // Gris un poco más claro (opcional)
    
    const line3 = document.createElement("p");
    line3.innerHTML = "*Puedes combinar diferentes modelos de la misma categoría para alcanzar la cantidad.";
    line3.style.margin = "0px auto"; // Espaciado superior
    line3.style.fontStyle = "italic"; // Texto en cursiva
    line3.style.color = "#555"; // Gris un poco más claro
    line3.style.fontSize = "0.9em"; // Tamaño de fuente ligeramente más pequeño
    line3.style.width= "90%";
    
    // Agregamos las líneas al contenedor
    //legend.appendChild(line1);
    //legend.appendChild(line2);
    legend.appendChild(line3);
    
    // Finalmente, agregamos la leyenda al elemento deseado
    elementToMove.appendChild(legend);

    if (elementToMove && referenceElement) {
      // Verificar que comparten el mismo padre
      if (elementToMove.parentNode === referenceElement.parentNode) {
        referenceElement.parentNode.insertBefore(elementToMove, referenceElement);
        console.log('Elemento movido exitosamente');
        
      } else {
        console.error('Los elementos no comparten el mismo padre');

        referenceElement.innerHTML = "";
        referenceElement.appendChild(elementToMove);
        
        
      }
    }

    
    //obs.disconnect(); // Dejar de observar
  });

  // Comenzar a observar el documento con las configuraciones deseadas:
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true
  });

  // Opcional: establecer un timeout como respaldo
  // const timeout = setTimeout(() => {
    // observer.disconnect();
    // console.warn('Tiempo de espera agotado, elementos no encontrados');
  // }, 30000); // 10 segundos como máximo
});
